<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { SCDrawer } from '@nsftx/seven-components'
import { useWalletBalanceStore } from '@/stores/wallet/walletBalanceStore'
import { useWalletStore } from '@/stores/wallet/walletStore'
import STWalletBalanceDetailsMultiple from './STWalletBalanceDetailsMultiple.vue'
import STWalletBalanceDetailsSingle from './STWalletBalanceDetailsSingle.vue'
import { NXGDSVScrollContainer } from '@nsftx/seven-nxg-design-system'

// stores
const { hasMultipleWallets } = storeToRefs(useWalletStore())
const walletBalanceStore = useWalletBalanceStore()
const { hideWalletBalanceDetailsModal, hideWalletBalanceMultipleItemModal } = walletBalanceStore
const { isWalletBalanceDetailsModalOpened } = storeToRefs(walletBalanceStore)

// methods
const closeModal = () => {
  hideWalletBalanceDetailsModal()
  hideWalletBalanceMultipleItemModal()
}
</script>

<template>
  <Teleport to="body">
    <SCDrawer
      :model-value="isWalletBalanceDetailsModalOpened"
      position="right"
      with-close-icon
      @update:model-value="closeModal"
    >
      <div class="st-wallet-balance-details st-d-flex-column st-h-100">
        <div class="sc-px-6 sc-pt-6 sc-pb-5 sc-mb-5 sc-text-h4 sc-text-primary-1">
          {{ $t('common_balance') }}
        </div>
        <NXGDSVScrollContainer container-class="st-flex-fill sc-px-6" :show-scroll-to-top="false">
          <STWalletBalanceDetailsMultiple v-if="hasMultipleWallets" />
          <STWalletBalanceDetailsSingle v-else />
        </NXGDSVScrollContainer>
      </div>
    </SCDrawer>
  </Teleport>
</template>

<style lang="scss" scoped>
.st-wallet-balance-details {
  width: 30vw;
}
</style>
